<template>
    <div>
        <CommonModal size="md" ref="processingModal" :footer="true" :onHideOnlyX="true" :closeBtn="false">
            <template v-slot:CommonModalTitle>
                <div>{{ $t('processing')+'...' }}</div>
            </template>
            <template v-slot:CommonModalContent>
                <b-row>
                    <b-col cols="12" class="d-flex justify-content-center">
                        <b-icon variant="primary" icon="gear-wide-connected" animation="spin-pulse" font-scale="4"></b-icon>
                    </b-col>
                </b-row>
            </template>
            <template v-slot:CommonModalFooter>
                {{ $t('bulk_grade_entry_processing_info') }}
            </template>
        </CommonModal>
    </div>
</template>
<script>
//Component
import CommonModal from "@/components/elements/CommonModal"

//Service
import SystemService from "@/services/SystemService"

export default {
    components: {
        CommonModal
    },
    props: {
        keyParameter: {
            type: String,
            default: null,
        }
    },
    data() {
        return {
            intervalId: null
        }
    },
    mounted() {
        if (this.keyParameter) {
            this.showModalAndStartPolling();
        }
    },
    watch: {
        keyParameter: {
            handler(value) {
                if (value) {
                    this.showModalAndStartPolling();
                } else {
                    this.stopPolling();
                    if (this.$refs.processingModal && this.$refs.processingModal.$refs.commonModal) {
                        this.$refs.processingModal.$refs.commonModal.hide();
                    }
                }
            }
        }
    },
    beforeDestroy() {
        this.stopPolling();
    },
    methods: {
        showModalAndStartPolling() {
            this.$nextTick(() => {
                if (this.$refs.processingModal && this.$refs.processingModal.$refs.commonModal) {
                    this.$refs.processingModal.$refs.commonModal.show()
                    this.stopPolling()
                    this.logControl()
                    this.intervalId = setInterval(() => {
                        this.logControl()
                    }, 5000)
                }
            });
        },
        stopPolling() {
            if (this.intervalId) {
                clearInterval(this.intervalId);
                this.intervalId = null;
            }
        },
        logControl() {
            if (!this.keyParameter) return;
            let key = this.keyParameter.replace(/\//g, "_");
            SystemService.jobControl(key)
                .then(response => {
                    const result = (response.data && typeof response.data === 'object' && response.data.hasOwnProperty('data'))
                        ? response.data.data
                        : response.data;

                    if (result == "") {
                        if (this.$refs.processingModal && this.$refs.processingModal.$refs.commonModal) {
                            this.$refs.processingModal.$refs.commonModal.hide();
                        }
                        this.stopPolling();
                        this.$emit('stopPolling', true)
                    }
                })
                .catch(e => {
                    this.stopPolling();
                    if (this.$refs.processingModal && this.$refs.processingModal.$refs.commonModal) {
                        this.$refs.processingModal.$refs.commonModal.hide();
                    }
                });
        }
    }
};
</script>
